import * as types from "./actionTypes";

export const setModalAPIVisibility = (payload) => ({
  type: types.APP_MODE_API_MODAL,
  payload
});
